const APPS_CONFIG = {
  1: {
    id: 1,
    key: "app1",
    themeName: "app1",
    hostMatchers: ["mesbonsplans.klesia"],
    websiteUrl: "https://mesbonsplans.klesia.fr",
    pageTitle: "Mes bons plans Klesia Pro",
    favicon: "/favicon.ico",
    organisationName: "MES-BONS-PLANS-KLESIA-PRO",
    mobileOrganisationName: "MES-BONS-PLANS-KLESIA",
    contactEmail: "klesia-pro@hapluspme.com",
    desktopRedirectUrl: "https://mesbonsplans-klesia.reducce.fr/autologin/",
    guidePdfUrl: "/docs/guide-connexion-mobile-klesia.pdf",
    themeColors: {
      "--theme-primary": "#5b494c",
      "--theme-primary-active": "#47383b",
      "--theme-accent": "#ea921a",
      "--theme-accent-active": "#d6820d",
    },
  },
  2: {
    id: 2,
    key: "app2",
    themeName: "app2",
    hostMatchers: ["mesbonsplans.klesiamut"],
    websiteUrl: "https://mesbonsplans.klesiamut.fr",
    pageTitle: "Mes bons plans Klesia Mut",
    favicon: "/favicon.ico",
    organisationName: "MES-BONS-PLANS-KLESIA-MUT",
    contactEmail: "klesia-mut@hapluspme.com",
    desktopRedirectUrl: "https://mesbonsplans-klesiamut.reducce.fr/autologin/",
    guidePdfUrl: "/docs/guide-connexion-mobile-klesiamut.pdf",
    themeColors: {
      "--theme-primary": "#5b494c",
      "--theme-primary-active": "#47383b",
      "--theme-accent": "#ea921a",
      "--theme-accent-active": "#d6820d",
    },
  },
  3: {
    id: 3,
    key: "app3",
    themeName: "app3",
    hostMatchers: ["mesbonsplans.carcept-prev"],
    websiteUrl: "https://mesbonsplans.carcept-prev.fr",
    pageTitle: "Mes bons plans Klesia Carcept",
    favicon: "/favicon.ico",
    organisationName: "MES-BONS-PLANS-KLESIA-CARCEPT",
    contactEmail: "klesia-carcept@hapluspme.com",
    desktopRedirectUrl:
      "https://mesbonsplans-carcept-prev.reducce.fr/autologin/",
    guidePdfUrl: "/docs/guide-connexion-mobile-carcept-prev.pdf",
    themeColors: {
      "--theme-primary": "#75388c",
      "--theme-primary-active": "#5c2b6b",
      "--theme-accent": "#ea921a",
      "--theme-accent-active": "#d6820d",
    },
  },
  4: {
    id: 4,
    key: "app4",
    themeName: "app4",
    hostMatchers: ["mesbonsplansghr.hapluspme"],
    websiteUrl: "https://mesbonsplansghr.hapluspme.com",
    pageTitle: "Mes bons plans GHR",
    favicon: "/favicon-ghr.png",
    organisationName: "MES-BONS-PLANS-GHR",
    contactEmail: "ghr@hapluspme.com",
    desktopRedirectUrl: "https://mesbonsplans-ghr.reducce.fr/autologin/",
    guidePdfUrl: "/docs/guide-connexion-app-reducce-marques-grises.pdf",
    themeColors: {
      "--theme-primary": "#007bff",
      "--theme-primary-active": "#0056b3",
      "--theme-accent": "#00bcd4",
      "--theme-accent-active": "#0097a7",
    },
  },
  5: {
    id: 5,
    key: "app5",
    themeName: "app5",
    hostMatchers: ["mesbonsplansagpm.hapluspme"],
    websiteUrl: "https://mesbonsplansagpm.hapluspme.com",
    pageTitle: "Mes bons plans AGPM",
    favicon: "/favicon-agpm.png",
    organisationName: "MES-BONS-PLANS-AGPM",
    contactEmail: "agpm@hapluspme.com",
    desktopRedirectUrl: "https://mes-bons-plans-agpm.reducce.fr/autologin/",
    guidePdfUrl: "/docs/guide-connexion-app-reducce-marques-grises.pdf",
    themeColors: {
      "--theme-primary": "#213067",
      "--theme-primary-active": "#182448",
      "--theme-accent": "#2E8CB1",
      "--theme-accent-active": "#256F8C",
    },
  },
  6: {
    id: 6,
    key: "app6",
    themeName: "app6",
    hostMatchers: ["mesbonsplansmedef.hapluspme"],
    websiteUrl: "https://mesbonsplansmedef.hapluspme.com",
    pageTitle: "Mes bons plans MEDEF",
    favicon: "/favicon-medef.png",
    organisationName: "MES-BONS-PLANS-MEDEF",
    contactEmail: "medef@hapluspme.com",
    desktopRedirectUrl: "https://mesbonsplans-medef.reducce.fr/autologin/",
    guidePdfUrl: "/docs/guide-connexion-app-reducce-marques-grises.pdf",
    themeColors: {
      "--theme-primary": "#322783",
      "--theme-primary-active": "#261D66",
      "--theme-accent": "#DE0432",
      "--theme-accent-active": "#B90329",
    },
  },
};

const DEFAULT_APP_NUMBER = 3;
const DEV_DEFAULT_APP_NUMBER = 2;
const DEV_PORT_MAP = {
  3001: 2,
};

const LOCALHOST_THEME = {
  "--theme-primary": "#2563eb",
  "--theme-primary-active": "#1d4ed8",
  "--theme-accent": "#ea921a",
  "--theme-accent-active": "#d6820d",
};

const getAppConfig = (appNumber) => APPS_CONFIG[Number(appNumber)];

const isValidAppNumber = (appNumber) => Boolean(getAppConfig(appNumber));

const getThemeNameByAppNumber = (appNumber) =>
  getAppConfig(appNumber)?.themeName;

const getThemeColorsByAppNumber = (appNumber) =>
  getAppConfig(appNumber)?.themeColors;

const getOrganisationNameByAppNumber = (appNumber) =>
  getAppConfig(appNumber)?.organisationName;

const getPageTitleByAppNumber = (appNumber) =>
  getAppConfig(appNumber)?.pageTitle ?? "Mes bons plans KLESIA";

const getFaviconByAppNumber = (appNumber) =>
  getAppConfig(appNumber)?.favicon ?? "/favicon.ico";

const getWebsiteUrlByAppNumber = (appNumber) =>
  getAppConfig(appNumber)?.websiteUrl;

const getContactEmailByAppNumber = (appNumber) =>
  getAppConfig(appNumber)?.contactEmail ?? "klesia-pro@hapluspme.com";

const resolveAppNumberFromHostname = (hostname) => {
  const priority = [6, 5, 4, 2, 3, 1];
  for (const appNumber of priority) {
    const config = getAppConfig(appNumber);
    if (config?.hostMatchers?.some((matcher) => hostname.includes(matcher))) {
      return appNumber;
    }
  }
  return null;
};

const resolveAppNumberFromEnvironment = ({ hostname, port, search }) => {
  const urlParams = new URLSearchParams(search);
  const appParam = urlParams.get("app");
  const appParamNumber = appParam ? Number(appParam) : null;

  if (isValidAppNumber(appParamNumber)) {
    localStorage.setItem("devAppNumber", String(appParamNumber));
    return appParamNumber;
  }

  const hostnameMatch = resolveAppNumberFromHostname(hostname);
  if (hostnameMatch) {
    return hostnameMatch;
  }

  if (
    hostname === "localhost" ||
    hostname === "127.0.0.1" ||
    hostname.includes("192.168")
  ) {
    const storedApp = Number(localStorage.getItem("devAppNumber"));
    if (isValidAppNumber(storedApp)) {
      return storedApp;
    }

    const portApp = DEV_PORT_MAP[port];
    if (isValidAppNumber(portApp)) {
      localStorage.setItem("devAppNumber", String(portApp));
      return portApp;
    }

    localStorage.setItem("devAppNumber", String(DEV_DEFAULT_APP_NUMBER));
    return DEV_DEFAULT_APP_NUMBER;
  }

  return DEFAULT_APP_NUMBER;
};

export {
  APPS_CONFIG,
  DEFAULT_APP_NUMBER,
  DEV_DEFAULT_APP_NUMBER,
  LOCALHOST_THEME,
  getAppConfig,
  getFaviconByAppNumber,
  getOrganisationNameByAppNumber,
  getPageTitleByAppNumber,
  getThemeColorsByAppNumber,
  getThemeNameByAppNumber,
  getWebsiteUrlByAppNumber,
  isValidAppNumber,
  resolveAppNumberFromEnvironment,
  getContactEmailByAppNumber,
};
